<div class="tw-text-center tw-font-extrabold tw-text-xl md:tw-text-3xl tw-pb-4">Our Presence</div>
<div class="tw-text-center tw-text-xs md:tw-text-sm tw-pb-16 tw-px-4">Driving India Forward: Nationwide Leasing in 55+ Cities with Strong Tech Ecosystem</div>
<div class="container tw-grid md:tw-grid-cols-2 tw-gap-12">
    <div>
        <div
            class="tw-text-center tw-font-extrabold md:tw-text-xl tw-px-4 tw-py-8 tw-rounded tw-bg-[#F7B703]/[0.4] tw-mb-6">
            Pan
            India Operational Capability
            Through <br> Strong Technology Ecosystem</div>
        <div
            class="tw-text-center tw-font-extrabold md:tw-text-xl tw-px-4 tw-py-8 tw-rounded tw-bg-[#F7B703]/[0.2] tw-mb-2">
            Our
            Network</div>
        <div class="tw-px-4 tw-py-8 tw-rounded tw-shadow tw-text-sm">
            <ul class="tw-leading-loose">
                <li> <span class="tw-font-bold tw-pr-1">250+</span> Certified Dealer Network Pan India</li>
                <li><span class="tw-font-bold tw-pr-1">500+</span> Preferred Service Partners Pan India</li>
                <li><span class="tw-font-bold tw-pr-1">97%</span> Same Day Deliveries for Repair/Service</li>
            </ul>
        </div>
        <div
            class="tw-text-center tw-font-extrabold md:tw-text-xl tw-px-4 tw-py-8 tw-rounded tw-bg-[#F7B703]/[0.2] tw-my-6">
            Presence in 55+ Cities</div>
    </div>
    <div class="tw-px-6">
        <img src="/assets/images/corporate/IndiaMap.svg" alt="Pan
        India Operational Capability">
    </div>
</div>